import { inject, type InjectionKey } from 'vue'
import type { CreateSupportSessionFormProps } from '../forms/FormCreateSupportSession.vue'
import type { ShowEndSupportSessionDialogParams } from '../modals/SupportSessionModalEnd.vue'
import type { ShowEndSupportSessionAssignedDialogParams } from '../modals/SupportSessionModalEndAssigned.vue'
import type { ShowSupportSessionDetailsDialogParams } from '../modals/SupportSessionModalDetails.vue'

/**
 * Injection contract for the support-session modals. Kept in this dedicated
 * leaf module — not in the `providers/index.ts` barrel — so
 * `SupportModalProvider` and the modals can import the key/hook without
 * forming a barrel↔member import cycle.
 */
export interface SupportModalsContext {
  showCreateSupportSession: (params: CreateSupportSessionFormProps) => void
  /** End-user confirm: just ends the granted session. */
  showEndSupportSession: (params: ShowEndSupportSessionDialogParams) => void
  /**
   * Gatship-user confirm: ends a session from the assigned list. Ending
   * the session a tab is currently inside is SupportSessionModalEndCurrent,
   * hosted by SupportSessionHeader.
   */
  showEndSupportSessionAssigned: (
    params: ShowEndSupportSessionAssignedDialogParams
  ) => void
  showSupportSessionDetails: (
    params: ShowSupportSessionDetailsDialogParams
  ) => void
}

export const supportModalsKey = Symbol(
  'support-modals'
) as InjectionKey<SupportModalsContext>

export function useSupportModals() {
  return inject(supportModalsKey)
}
